// extracted by mini-css-extract-plugin
module.exports = {"item":"BusinessWeekly_item__13Dsf","subscribe":"BusinessWeekly_subscribe__2E8Fv","indicator":"BusinessWeekly_indicator__2f9_Z","previewText":"BusinessWeekly_previewText__2GFhd"};